<template>
    <analytics-stat-card
        :loading="loading"
        :error="Boolean(error)"
        :percentage="true"
        :difference="dataComputed.difference"
        :value="dataComputed.number?.value"
        :color="dataComputed.difference < 0 ? 'bad' : 'good'"
        :direction="dataComputed.difference < 0 ? 'down' : 'up'"
    >
        <template v-slot:title>
            <slot name="title">Message Deliverability</slot>
        </template>
        <template v-slot:subtitle>
            <slot name="subtitle"></slot>
        </template>

        <span>{{ dataComputed.number?.label || '' }}</span>

        <template v-slot:explainHeader>Message Deliverability</template>
        <template v-slot:explainContent>
            <p>
                <strong>Message Deliverability</strong><br />
                PIn the Context of Messages sent, percentage of the messages successfully delivered relative to the
                messages attempted during the selected period.
            </p>

            <p>
                <strong>Message Deliverability %</strong><br />
                Variation of Message Deliverability relative to the previous period.
            </p>
        </template>
    </analytics-stat-card>
</template>
<script setup>
import { outboundMessagesAnalyticsClient } from '~/services';
import { computed, watch } from 'vue';
import AnalyticsStatCard from '../../partial/AnalyticsStatCard.vue';
import { formatPercentage } from '~/components/filters';
import { computeComparisonRange, calculateDifference, metricsInputValidator } from '~/utils/analytics';
import { useVersionedRequest } from '~/composables/useVersionedRequest';

const props = defineProps({
    fetchParams: {
        type: Object,
        required: true,
        validator: metricsInputValidator,
    },
    orgUnitId: {
        type: Number,
    },
    groupId: {
        type: String,
    },
});

const { loading, response, error, fetchData } = useVersionedRequest();

const dataComputed = computed(() => {
    const responseData = response.value?.data;

    if (!responseData?.values?.length) {
        return {
            number: undefined,
            difference: undefined,
        };
    }

    const number = responseData.values.length >= 2 ? responseData.values[1] : responseData.values[0];
    const difference = responseData.values.length >= 2 ? calculateDifference(responseData.values) : undefined;

    return {
        number: {
            value: number,
            label: formatPercentage(Math.abs(number)),
        },
        difference: difference,
    };
});

watch(
    [() => props.fetchParams],
    () => {
        const params = {
            ...props.fetchParams,
            range: computeComparisonRange(props.fetchParams.range, Boolean(props.groupId), Boolean(props.orgUnitId)),
        };

        fetchData(
            outboundMessagesAnalyticsClient.getDeliveryRate(
                {
                    teamId: Spark.state.currentTeam.id,
                    orgUnitId: props.orgUnitId,
                    groupId: props.groupId,
                },
                params
            )
        ).catch((e) => {
            console.error(e);
        });
    },
    { immediate: true, deep: true }
);

defineExpose({
    value: computed(() => dataComputed.value.number?.value),
    loading,
});
</script>
